/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const timeouts = {
    short: 4000,
    long: 8000,
};
export const positions = [
    'top-start',
    'top',
    'top-end',
    'bottom-start',
    'bottom',
    'bottom-end',
];
export const types = [
    'info',
    'success',
    'error',
    'warning',
    'high-alert',
    'snack-bar',
    'custom',
];
const defaultPositionData = positions.reduce((acc, cur) => (Object.assign({ [cur]: [] }, acc)), {});
const throwIfNotInContext = () => {
    throw new Error("Couldn't find the notification context. Is your app wrapped in `Starc` component?");
};
export const defaultContextData = {
    queues: defaultPositionData,
    show: throwIfNotInContext,
    hide: throwIfNotInContext,
    remove: throwIfNotInContext,
    add: throwIfNotInContext,
};
